<template>
  <div class="modal">
    <v-toolbar color="white" flat style="max-height: 64px">
      <v-container class="d-flex tb-full-width" style="width: 100%;">
        <v-spacer />
        <v-toolbar-items class="close">
          <v-btn
            id="close-iframe-modal"
            class="white--text"
            color="transparent"
            elevation="0"
            @click="closeModal"
          >
            <v-icon color="red" size="28">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-container>
    </v-toolbar>
    <div>
      <v-row>
        <v-spacer />
        <cropper
          ref="cropper"
          class="cropper"
          :src="image.src"
          :move-image="true"
          :resize-image="true"
          stencil-component="circle-stencil"
          :stencil-size="{
            height: 450,
            width: 450
          }"
          :stencil-props="{
            aspectRadio: 1,
            movable: false,
            resizable: false
          }"
        />
        <v-spacer />
      </v-row>
      <v-row class="pt-5 controls">
        <v-spacer />
        <div>
          <input
            type="file"
            ref="file"
            @change="uploadImage($event)"
            accept="image/*"
          />
          <v-btn small depressed @click="cropAndSavePlayerAvatar">
            Save
          </v-btn>
        </div>
        <v-spacer />
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "@/store/ModuleTypes";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import PlayerRegistrationPlayerDetailsBase from "@/views/academy/playerregistration/PlayerRegistrationPlayerDetailsBase";
import { readFile } from "fs";
export default {
  name: "PlayerAvatarCropModal",
  components: { Cropper },
  mixins: [PlayerRegistrationPlayerDetailsBase],
  data() {
    return {
      image: {
        src: null,
        type: null
      }
    };
  },
  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, ["playerAvatar"])
  },
  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, ["setPlayerAvatar"]),
    uploadImage(event) {
      const { files } = event.target;

      if (files && files[0]) {
        if (this.image.src) {
          URL.revokeObjectURL(this.image.src);
        }

        const blob = URL.createObjectURL(files[0]);
        this.image = {
          src: blob,
          type: files[0].type
        };
        this.setPlayerAvatar({ name: "file", value: files[0] });
        this.setPlayerAvatar({ name: "imageUrl", value: this.image.src });
        this.handleUploadPlayerAvatar(event);
      }
    },
    cropAndSavePlayerAvatar() {
      const result = this.$refs.cropper.getResult();

      this.setPlayerAvatar({
        name: "imageUrl",
        value: result.canvas.toDataURL(this.image.type)
      });

      let ext;
      switch (this.image.type) {
        case this.image.type.split("/")[1] === "png":
          ext = "png";
          break;
        case this.image.type.split("/")[1] === "jpg":
          ext = "jpg";
          break;
        case this.image.type.split("/")[1] === "heic":
          ext = "png";
          break;
        default:
          ext = "jpg";
      }

      this.setPlayerAvatar({
        name: "file",
        value: result.canvas.toDataURL(this.image.type)
      });
      result.canvas.toBlob(blob => {
        const file = new File([blob], "avatar." + ext, {
          type: this.image.type,
          lastModified: new Date(Date.now())
        });
        this.setPlayerAvatar({ name: "file", value: file });

        this.handleUploadPlayerAvatar(null);
      }, this.image.type);
    },
    zoom(val) {
      this.$refs.cropper.zoom(val);
    },
    closeModal() {
      this.$emit("close");
    }
  },
  mounted() {
    this.image = {
      src: this.playerAvatar.imageUrl ? this.playerAvatar.imageUrl : null,
      type: this.playerAvatar.imageUrl
        ? this.playerAvatar.imageUrl.split(":")[1].split(";")[0]
        : null
    };
  },
  unmounted() {
    if (this.image.src) {
      URL.revokeObjectURL(this.image.src);
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  margin-left: 25%;
  height: 675px;
  width: 675px;
  z-index: 1000;
  background-color: white;
}
.cropper {
  height: 450px;
  width: 450px;
}
@media (max-width: 600px) {
  .modal {
    margin-left: 0;
    max-width: 100%;
  }
  .controls {
    margin: 5px 5px 5px 5px;
    width: 75%;
  }
}
</style>
